import { EnumConsoleType } from '@/contracts/system-modules/console/enum/EnumConsoleType'

export default class ConsoleRecord {
  private readonly time: string
  private readonly type: EnumConsoleType
  private readonly message: string
  private readonly vars: object[]

  constructor(type: EnumConsoleType, message: string, vars: object[]) {
    this.time = `${String(new Date().getDate()).padStart(2, '0')}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${new Date().getFullYear()} ${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}:${String(new Date().getSeconds()).padStart(2, '0')}`
    this.type = type
    this.message = message
    this.vars = vars
  }

  getTime(): string {
    return this.time
  }

  getType(): EnumConsoleType {
    return this.type
  }

  getMessage(): string {
    return this.message
  }

  getVars(): object[] {
    return this.vars
  }
}
